module.exports = __webpack_public_path__ + "img/46.3.TP.4fa4cf28.png";